import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";
import env from "./env";

const firebaseConfig = {
    apiKey: env.FIREBASE_API_KEY,
    authDomain: env.FIREBASE_AUTH_DOMAIN,
    projectId: env.FIREBASE_PROJECT_ID,
    storageBucket: env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: env.FIREBASE_MESSAGE_SENDER_ID,
    appId: env.FIREBASE_APP_ID,
    measurementId: env.FIREBASE_MEASURMENT_ID,
};

const app = initializeApp(firebaseConfig);

if (typeof window !== "undefined") {
    try {
        getAnalytics(app);
    } catch (error) {
        console.log("Firebase analytics init error:", error);
    }
}

export const getFirebaseMessageToken = async () => {
    try {
        const support = await isSupported();

        if (!support) {
            return { error: "Notification not supported" };
        }

        const messaging = getMessaging(app);

        const tokenId = await getToken(messaging, {
            vapidKey: env.FIREBASE_VAP_ID_KEY,
        });

        if (!tokenId) {
            return { error: "Unable to get FCM token" };
        }

        return { tokenId };
    } catch (error) {
        console.log("getFirebaseMessageToken error:", error);
        return { error };
    }
};

export const requestNotification = async () => {
    try {
        if (typeof window === "undefined") return "";

        if (!("Notification" in window)) {
            console.log("This browser does not support desktop notification");
            return "";
        }

        if (Notification.permission === "granted") {
            const { tokenId, error } = await getFirebaseMessageToken();
            if (error) {
                console.log("requestNotification error:", error);
                return "";
            }
            return tokenId || "";
        }

        if (Notification.permission !== "denied") {
            const permission = await Notification.requestPermission();

            if (permission === "granted") {
                const { tokenId, error } = await getFirebaseMessageToken();
                if (error) {
                    console.log("requestNotification error:", error);
                    return "";
                }
                return tokenId || "";
            }
        }

        return "";
    } catch (error) {
        console.log("requestNotification catch error:", error);
        return "";
    }
};

/**
 * Foreground message listener
 * App open hone par yeh call hoga.
 * Yahan tum toast / UI badge / custom popup dikha sakte ho.
 * Browser notification yahan manually mat show karo agar duplicate avoid karna hai.
 */
export const onMessageListener = async (
    callback: (payload: any) => void
) => {
    try {
        const support = await isSupported();
        if (!support) return;

        const messaging = getMessaging(app);

        onMessage(messaging, (payload) => {
            console.log("Foreground message received:", payload);
            callback(payload);
        });
    } catch (error) {
        console.log("onMessageListener error:", error);
    }
};

export default app;